import { Container, Typography, makeStyles } from "@material-ui/core";

import Button from "@material-ui/core/Button";
import { DropdownMenuButton } from "../components-atoms";
import Menu from "@material-ui/core/Menu";
import React from "react";
import UnfoldMoreRoundedIcon from '@material-ui/icons/UnfoldMoreRounded';
import { ITheme, theme } from "../constants/theme";

// import ClickAwayListener from "@material-ui/core/ClickAwayListener";
export default function ShopSortButton(props: any) {
  const { selectedSortType, handleSort } = props;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const DropdownItemSelected = (item: string) => {
    switch (item) {
      case "County":
        handleSort(0);
        break;
      case "Alphabetical ascending":
        handleSort(1);
        break;
      case "Alphabetical descending":
        handleSort(2);
        break;
      default:
        break;
    }
  };

  return (
    <div>
      <Button
        id="shop-sort-button"
        aria-label="Sort"
        aria-controls={open ? "shop-sort-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        startIcon={<UnfoldMoreRoundedIcon color="primary" />}
        onClick={handleClick}
        style={{
          marginLeft: props.inButtonSet ? "12px" : undefined,
          backgroundColor: open ? theme.palette.secondary.main : undefined,
        }}
        className={classes.textButton}
      >
        {/* <img src={printIcon} className={classes.buttonIcon} alt="printIcon" /> */}
        <Typography
          variant="button"
          component="span"
          color="primary"
          className={classes.printButtonText}
        >
          Sort
        </Typography>
      </Button>

      <Menu
        id="shop-sort-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "shop-sort-button",
          role: "listbox",
        }}
        className={classes.menu}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Container className={classes.root}>
          <DropdownMenuButton
            title="County"
            value="County"
            handleClick={DropdownItemSelected}
            selected={selectedSortType === 0 ? true : false}
          />
          <DropdownMenuButton
            title="Alphabetical ascending"
            value="Alphabetical ascending"
            handleClick={DropdownItemSelected}
            selected={selectedSortType === 1 ? true : false}
          />
          <DropdownMenuButton
            title="Alphabetical descending"
            value="Alphabetical descending"
            handleClick={DropdownItemSelected}
            selected={selectedSortType === 2 ? true : false}
          />
        </Container>
      </Menu>
    </div>
  );
}

const useStyles = makeStyles((theme: ITheme) => ({
  printButtonText: {
    textTransform: "none",
  },
  buttonIcon: {
    width: 18,
    height: 18,
    marginRight: 8,
  },
  menu: {
    marginTop: 120,

    "& [class*=MuiPaper-rounded-]": {
      borderRadius: 12,
    },
  },
  root: {
    width: 256,
    padding: "12px 4px",
    borderRadius: 12,
  },
  textButton: {
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
    "&:active": {
      backgroundColor: theme.palette.secondary[24],
    },
  },
}));
